// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
// @author: Taehoon Moon 2014
import { Note } from './note';
import { TimeSignature } from './timesignature';
import { Category } from './typeguard';
export class TimeSigNote extends Note {
    static get CATEGORY() {
        return Category.TimeSigNote;
    }
    constructor(timeSpec, customPadding) {
        super({ duration: 'b' });
        this.timeSig = new TimeSignature(timeSpec, customPadding);
        this.setWidth(this.timeSig.getWidth());
        // Note properties
        this.ignoreTicks = true;
    }
    /* Overridden to ignore */
    // eslint-disable-next-line
    addToModifierContext(mc) {
        // DO NOTHING.
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        this.timeSig.drawAt(ctx, stave, this.getAbsoluteX());
    }
}
